import { PropsWithChildren, createContext, useEffect, useState } from 'react';
import { SidebarExtensionContextType } from './types';
import { Sidebar } from '../../components/Sidebar';
import { SidebarItem } from '../../components/Sidebar/types';
import { SidebarExtension } from '../../components/SidebarExtension';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

export const SidebarExtensionContext =
  createContext<SidebarExtensionContextType>(null);

export const SidebarExtensionProvider = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const [sidebarItems, setSidebarItems] = useState<SidebarItem[]>([]);

  useEffect(() => {
    closeSidebarExtension();
  }, [location.pathname]);

  const openSidebarExtension = (data: SidebarItem[]) => {
    if (JSON.stringify(data) !== JSON.stringify(sidebarItems)) {
      setSidebarItems(data);
    }
  };

  const closeSidebarExtension = () => {
    if (!!sidebarItems.length) {
      setSidebarItems([]);
    }
  };

  const content = (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        '@media(max-width: 900px)': {
          flexDirection: 'column',
        },
      }}
    >
      {!!sidebarItems.length && <SidebarExtension items={sidebarItems} />}
      {children}
    </Box>
  );

  return (
    <SidebarExtensionContext.Provider
      value={{
        openSidebarExtension,
        closeSidebarExtension,
      }}
    >
      {content}
    </SidebarExtensionContext.Provider>
  );
};
